import { render, staticRenderFns } from "./ChineesHoro.vue?vue&type=template&id=33908a57&"
import script from "./ChineesHoro.vue?vue&type=script&lang=js&"
export * from "./ChineesHoro.vue?vue&type=script&lang=js&"
import style0 from "./ChineesHoro.vue?vue&type=style&index=0&id=33908a57&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports